<template>
  <div class="basic_wrap">
    <bsHeader
      :title="$t('utils.lunlog40')"
      @backurl="$router.back()"
    />
    <div class="block_div auth_wrap">
      <form class="form">
        <div class="item">
          <input
            v-model.trim="email"
            type="text"
            class="inp"
            :placeholder="$t('auth.emailEmpty')"
            readonly
          >
        </div>
        <div class="item">
          <input
            v-model.trim="account.code"
            type="text"
            class="inp"
            :placeholder="$t('auth.emailCode')"
          >
          <van-count-down
            :time="time"
            class="btn get_captcha"
            style="line-height: 40px;"
            @finish="timeCall"
          >
            <template v-slot="timeData">
              <span @click="sendcode">{{
                timeData.seconds > 0
                  ? timeData.seconds
                  : $t('auth.sendEmailCode')
              }}</span>
            </template>
          </van-count-down>
        </div>
        <div
          class="bind_wrap"
          style="margin-top: 0px;"
        > 
          <div class="bind_item">
            <p class="item_name">
              {{ $t('wallet.bank') }}
            </p>
            <div class="block_div item_input">
              <van-dropdown-menu>
                <van-dropdown-item
                  v-model="value1"
                  :options="option1"
                />
              </van-dropdown-menu>
            </div>
          </div>
          <div class="bind_item">
            <p class="item_name">
              {{ $t('wallet.name') }}
            </p>
            <div class="block_div item_input">
              <van-field
                v-model="account.name"
                type="text"
                :placeholder="$t('wallet.namePlaceholder')"
              />
            </div>
          </div>
          <div class="bind_item">
            <p class="item_name">
              {{ $t('wallet.account') }}
            </p>
            <div class="block_div item_input">
              <van-field
                v-model="account.account"
                type="digit"
                :placeholder="$t('wallet.accountPlaceholder')"
              />
            </div>
          </div>
          <div class="tips">
            <p class="tips1">
              <span>*</span>{{ $t('wallet.walletTips1') }}
            </p>
            <!-- <p class="tips2"><span>*</span>{{$t('wallet.walletTips2')}}</p> -->
          </div>
          <div
		  style="background: #e50914;"
            class="basic_btn btn"
            :class="account.name==''||account.account==''?'no_touch':''"
            @click="submit()"
          >
            {{ $t('wallet.bindNow') }}
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
	import Vue from 'vue';
	import bsHeader from '../../components/bsHeader.vue'
	import Fetch from '../../utils/fetch'
	import {
		CountDown,
		Checkbox,
		Field,
		CellGroup,
		DropdownMenu,
		DropdownItem
	} from "vant";

	Vue.use(Field).use(CellGroup).use(DropdownMenu).use(DropdownItem).use(CountDown).use(Checkbox);
	export default {
		name: "WalletBank",
		components: {
			bsHeader
		},
		data() {
			return {
				data: [],
				account: {
					id: '',
					bank: '',
					name: '',
					account: '',
					band_id:0,
					bank_id:'',
					code:'',
				},
				data: {},
				time: 0,
				email: '',
				code:'',
				value1: 0,
				option1: []
			};
		},
		created() {
			if (window.plus) {
				plus.navigator.setStatusBarBackground('#FFFFFF');
				plus.navigator.setStatusBarStyle('dark');
			}
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
			this.starts();
		},
		methods: {
			starts() {
				Fetch('/user/getAuthStatus').then((r) => {
					this.data = r.data; 
					this.email = r.data.email;
				});
			},timeCall() {
				this.is_send = false;
				this.time = 0;
			},
			start() {
				Fetch('/user/getWithdrawMethodById', {
					id: this.$router.history.current.params.code
				}).then(r => {
					this.account.id = r.data.withdraw.id;
					var banks = r.data.withdraw.banks;
					if(r.data.withdraw.band){
						var band = r.data.withdraw.band;
						this.account.band_id = r.data.withdraw.band.id;
						this.account.account = r.data.withdraw.band.account;
						this.account.name = r.data.withdraw.band.name;
						for (var i = 0; i <r.data.withdraw.banks.length; i++) {
							
							if (r.data.withdraw.band['bid'] == r.data.withdraw.banks[i]['id']) {
								this.value1= i;
							}
						}

					}
					for (var i = 0; i < banks.length; i++) {
						this.option1.push({
							text: banks[i].name,
							value: i,
							code: banks[i].code,
							id: banks[i].id
						})
					}
					
					
					
				})
			},sendcode() {
				if (this.is_send) {
					return false;
				}
				if (!this.email) {
					this.$toast(this.$t('auth.emailEmpty'));
					return false;
				}
				var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
				if (!reg.test(this.email)) {
					this.$toast(this.$t('auth.emailError'));
					return false;
				}
				this.is_send = true;

				Fetch("/user/getEmailCode", {
					email: this.email
				}).then(() => {
					this.time = 60 * 1000;
					this.$toast({
						background: "#07c160",
						message: this.$t('auth.sendsuccess'),
					});
				}).catch(() => {
					this.is_send = false;
				});
			},
			submit() {
				this.account.bank = this.option1[this.value1]['text'];
				this.account.bank_id = this.option1[this.value1]['id'];
				if (this.account.name.length > 16 || this.account.name.length < 2) {
					this.$toast(this.$t('wallet.nameError'));
					return false;
				}
				if (this.account.account.length > 20 || this.account.account.length < 6) {
					this.$toast(this.$t('wallet.accountError'));
					return false;
				}
				//纯数字
				var reg1 = /^[0-9]*$/;
				if (!reg1.test(this.account.account)) {
					this.$toast(this.$t('wallet.accountError'));
					return false;
				}
				//console.log(this.account);return false;
				Fetch('/user/setWallet', {
					...this.account,
				}).then(r => {
					if(r.code=='218'){
						this.$toast(this.$t(r.info));return false;
					}else{
						
						this.$router.replace('/user')
					}
				})

			}
		}
	};
</script>

<style lang="less" scoped>
	.basic_wrap{
		position: relative;
		overflow: hidden;
		min-height: 100vh;
		background: #000;
	}
	.bind_wrap {
		margin-top: 0px;

		.bind_item {
			padding: 0px 0 0 0;

			.item_name {
				color: #000;
				margin: 10px 0 10px 5%;
			}
		}

		.tips {
			line-height: 2;
			width: 92%;
			margin: 5px 0 0 4%;
			font-size: 14px;

			span {
				margin-right: 5px;
			}

			.tips1 {
				color: #fbbf24;
			}
		}

		.btn {
			margin-top: 10px;
			color: #fff;
			font-size: 18px;
			font-weight: 700;
			letter-spacing: .4px;
			background: linear-gradient(100deg, #2e82ff, #1f6ae8 48%, #2ebdd2);opacity: .5;
		}
	}
.auth_wrap {
		margin-top: 30px;
		padding: 18px 15px;
		background: linear-gradient(155deg, hsla(0, 0%, 100%, .96), rgba(246, 250, 255, .94) 55%, rgba(236, 246, 255, .9));
		border: 1px solid rgba(176, 202, 240, .55);
		border-radius: 18px;
		box-shadow: 0 18px 34px rgba(24, 61, 122, .12), inset 0 1px 0 hsla(0, 0%, 100%, .9);
	}

	.auth_1 {
		text-align: center;
		margin-top: 50%;

		p {
			margin-top: 40px;
			font-size: 20px;
			color: green;
			font-weight: bold;
		}
	}

	.tittle_verified {
		margin-top: 10px;
		margin-bottom: 20px;
		font-size: 26px;
	}

	.tittle_verified_tips {
		line-height: 1.5;
	}

	.form {
		width: 100%;

		.item {
			height: 40px;
			font-size: 14px;
			display: flex;
			justify-content: flex-start;
			align-items: flex-end;
			padding-bottom: 4px;
			margin-bottom: 20px;
			color: #1a2742;
			border-radius: 12px;
			padding: 0 15px;
			background: rgba(248, 252, 255, .95);
			border: 1px solid #d8e6fb;
			transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease;
			
			input {
				height: 40px;
				flex: 1;
				color: #1a2742;
				&::placeholder {
					color: #000;
				}
			}
		}
	}

	/deep/ .van-dropdown-menu__bar {
		height: 44px;
		background-color: unset;
		box-shadow: unset;
		padding-left: 10px;
	}

	/deep/ .van-dropdown-menu__item {
		justify-content: left;

	}

	/deep/ .van-popup--top {
		width: 96%;
		margin-left: 2%;
	}

	/deep/ .van-overlay {
		background-color: unset;
	}
</style>
